import { Skeleton } from "@/components/ui/skeleton";

/**
 * Full-page loading skeleton shown while lazy-loaded pages are being fetched
 */
export function PageLoader() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header skeleton */}
      <div className="sticky top-0 z-50 bg-background border-b border-border">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Skeleton className="h-12 w-40" />
          <div className="hidden lg:flex items-center gap-6">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-10 w-32" />
          </div>
          <Skeleton className="lg:hidden h-10 w-10" />
        </div>
      </div>

      {/* Hero skeleton */}
      <div className="relative min-h-[60vh] bg-muted/30">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-2xl space-y-6">
            <Skeleton className="h-12 w-3/4" />
            <Skeleton className="h-12 w-1/2" />
            <Skeleton className="h-1 w-20" />
            <Skeleton className="h-6 w-full" />
            <Skeleton className="h-6 w-4/5" />
            <div className="flex gap-4 pt-4">
              <Skeleton className="h-12 w-40" />
              <Skeleton className="h-12 w-32" />
            </div>
          </div>
        </div>
      </div>

      {/* Content skeleton */}
      <div className="container mx-auto px-4 py-16">
        <div className="text-center space-y-4 mb-12">
          <Skeleton className="h-8 w-48 mx-auto" />
          <Skeleton className="h-4 w-96 mx-auto" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[...Array(6)].map((_, i) => (
            <Skeleton key={i} className="h-64 rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  );
}

/**
 * Compact loading skeleton for smaller page sections
 */
export function CompactPageLoader() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="w-full max-w-4xl mx-auto px-4 space-y-8">
        <div className="text-center space-y-4">
          <Skeleton className="h-10 w-1/3 mx-auto" />
          <Skeleton className="h-4 w-1/2 mx-auto" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...Array(6)].map((_, i) => (
            <Skeleton key={i} className="h-48 rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
